import { useState } from "react";
import "./style.css";
import { Routes, Route, useNavigate } from "react-router-dom";

const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_ORIGIN;

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const handleSubmit = async (event) => {
    event.preventDefault();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ email, password })
    };
    const response = await fetch(`${BACKEND_ORIGIN}/login`, requestOptions);
    const data = await response.json();
    if (response.ok) {
      localStorage.setItem("user", JSON.stringify({
        firstName: data.user.firstName,
        lastName: data.user.lastName,
        userName: data.user.userName,
        uuid: data.user.uuid
      }));
      navigate("/app");
    }
    else {
      alert("Error logging in: " + data.message);
    }
  }
  return (
    <div className="app-shell">
      <div className="main">
        <div className="logo-text" style={{display: "flex", fontSize: "64px", justifyContent: "center", alignItems: "center"}}>POST<span>GAME</span></div>
        <div className="logo-text" style={{display: "flex", fontSize: "56px", justifyContent: "center", alignItems: "center", paddingTop: "100px"}}>
          LOG<span>IN</span>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{paddingLeft: "35%", paddingRight: "35%"}}>
            <div style={{display: "flex", justifyContent:"space-between", alignItems: "center", paddingBottom: "10px"}}>
              <input className="chat-input" type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}></input>
              <input className="chat-input" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}></input>
            </div>
            <div>
              <button className="sign-button" type="submit">Login</button>
              <div><a href="./">Don't have an account?</a></div>
            </div>
          </div>
        </form>
     </div>
    </div>
  );
};

export default Login;
